import React, { useState, useCallback } from "react";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { btn, btnGhost, Notice, useRewardsPerms } from "./shared";
import { WalletBar, PayoutsTab, ReplayCreditCard } from "./PayoutsTab";
import ClaimsTab from "./ClaimsTab";
import RewardsWalletTab from "./RewardsWalletTab";
import DropsTab from "./DropsTab";
import PriceTab from "./PriceTab";
import { WalletsTab, ReferralsTab } from "./ExplorerTabs";

document.title = "Rewards | BiorGov Admin";

const TABS = [
  { id: "wallets", label: "Wallets" },
  { id: "referrals", label: "Referrals" },
  { id: "claims", label: "Claims" },
  { id: "payouts", label: "Payouts" },
  { id: "wallet", label: "Rewards wallet" },
  { id: "drops", label: "Drops" },
  { id: "price", label: "Weekly Price" },
];

const Rewards = () => {
  const [tab, setTab] = useState("wallets");
  const [wallet, setWallet] = useState(null);
  const [notice, setNotice] = useState(null);
  const flash = useCallback((type, text) => setNotice({ type, text }), []);
  const perms = useRewardsPerms();

  return (
    <div className="page-content">
      <div className="container-fluid">
        <BreadCrumb title="Rewards" pageTitle="In the app" />
        <Notice notice={notice} onClose={() => setNotice(null)} />
        {perms.payouts && <WalletBar wallet={wallet} setWallet={setWallet} flash={flash} />}
        <div style={{ display: "flex", gap: 8, marginBottom: 16, flexWrap: "wrap" }}>
          {TABS.map((t) => (
            <button key={t.id} style={tab === t.id ? btn : btnGhost} onClick={() => setTab(t.id)}>{t.label}</button>
          ))}
        </div>
        {tab === "wallets" && <WalletsTab flash={flash} />}
        {tab === "referrals" && <ReferralsTab flash={flash} />}
        {tab === "claims" && <ClaimsTab flash={flash} />}
        {tab === "payouts" && (
          <>
            {perms.replay && <ReplayCreditCard flash={flash} />}
            <PayoutsTab wallet={wallet} setWallet={setWallet} flash={flash} canPay={perms.payouts} />
          </>
        )}
        {tab === "wallet" && <RewardsWalletTab flash={flash} canRefill={perms.payouts} />}
        {tab === "drops" && <DropsTab flash={flash} canDrops={perms.drops} />}
        {tab === "price" && <PriceTab flash={flash} canPublish={perms.price} />}
      </div>
    </div>
  );
};

export default Rewards;
